export default [
  'MTN_Rwanda',
  'AIRTEL_Rwanda',
  'GT_Bank',
  'Access_bank',
];
